/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Button, Dialog, Divider, DialogTitle, Typography, IconButton, Tooltip, TextField, CircularProgress } from '@material-ui/core'
import { Close, Refresh, Add } from '@material-ui/icons'

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../../../../tableIcons";

import ErrorMessage from '../../../../Common/ErrorMessage';

import Actions from '../../../../../fluid/Actions/ActionFactory'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
        closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    }
})

const CustomDialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <DialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <Close />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
});

class Checkpoints extends Component {
    state = {
        checkpoints : [],
        loading_checkpoints : false,
        loading_error : false,
        err : null,
        adding_checkpoint : false,
        name : "",
        comments : "",
        submitting_checkpoint: false
    }

    componentDidMount () {
        this.getCheckpoints()
    }

    getCheckpoints = () => {
        this.setState({...this.state, loading_checkpoints : true, loading_error : false}, () => {
            Actions("http_request", {
                url : "/sainapse/irc/checkpoints",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    version : this.props.version,
                    step_tag : this.props.step_tag
                }
            }).then(res => {
                this.setState({...this.state, loading_checkpoints : false, loading_error : false, checkpoints : res.data.result.Result.checkpoints})
            }).catch(err => {
                this.setState({...this.state, loading_checkpoints : false, loading_error : true, err : err})
            })
        })
    }

    addCheckpoint = () => {
        this.setState({...this.state, submitting_checkpoint: true}, () => {
            Actions('http_request', {
                url : "/sainapse/irc/add_checkpoint",
                method : "post",
                data : {
                    checkpoint_type: "Manual",
                    comments: this.state.comments,
                    ic_name: this.props.ic_name,
                    name: null,
                    version: this.props.version,
                    step_tag : this.props.step_tag
                }
            }).then(res => {
                this.setState({...this.state, submitting_checkpoint: false, adding_checkpoint : false, name : "", comments : ""}, () => this.getCheckpoints())
            }).catch(err => {
                this.setState({...this.state, submitting_checkpoint: false, adding_checkpoint : false, name : "", comments : ""})
            })
        })
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Dialog 
                    fullWidth
                    open = {this.props.open}
                    maxWidth = "xl"
                    onClose = {this.props.close}
                >
                    <CustomDialogTitle onClose = {this.props.close}>Checkpoints</CustomDialogTitle>
                    <div style = {{width : '100%', height : '80vh', padding : '20px'}}>
                        {this.state.adding_checkpoint && 
                        <div style = {{width : '100%', padding : '10px'}}>
                            <Typography style = {{marginBottom : '10px'}} variant = 'subtitle2'>Add Checkpoint</Typography>
                            {/* <TextField
                                style = {{marginBottom : '10px'}}
                                variant = 'outlined'
                                fullWidth
                                label = "Name"
                                onChange = {(event) => this.setState({...this.state, name : event.target.value})}
                                value = {this.state.name}
                                size = 'small'
                            /> */}
                            <TextField
                                style = {{marginBottom : '10px'}}
                                variant = 'outlined'
                                fullWidth
                                multiline
                                label = "Comments"
                                rows={4}
                                onChange = {(event) => this.setState({...this.state, comments : event.target.value})}
                                value = {this.state.comments}
                                size = 'small'
                            />
                            <Button 
                                color = 'primary' 
                                onClick = {this.addCheckpoint}
                                startIcon = {this.state.submitting_checkpoint && <CircularProgress variant = 'indeterminate' size = {20}/>}
                            >Submit</Button>
                            <Button color = 'secondary' onClick = {() => this.setState({...this.state, adding_checkpoint: false, name : "", comments : ""})}>Cancel</Button>
                        </div>}
                        <MaterialTable
                            style = {{ width: "100%" }}
                            icons = {table_icons}
                            title = ""
                            columns = {[
                                {
                                    title : "Version",
                                    field : "version"
                                },
                                {
                                    title : "Name",
                                    field : "name"
                                },
                                {
                                    title : "Comments",
                                    field : "comments"
                                },
                                {
                                    title : "Timestamp",
                                    field : "timestamp",
                                    type: "datetime",
                                    defaultSort: "desc"
                                },
                                {
                                    title : "Type",
                                    field : "type"
                                },
                                {
                                    title : "Actions",
                                    field : "name",
                                    render : (rowData) => {
                                        return (
                                            <Button
                                                color = 'primary'
                                                onClick = {() => this.props.load_checkpoint(rowData)}
                                            >
                                                Load
                                            </Button>
                                        )
                                    }
                                }
                            ]}
                            data = {this.state.checkpoints}
                            option = {{
                                cellStyle: {
                                    height: "15px",
                                    paddingTop: 0,
                                    paddingBottom: 0
                                },
                                headerStyle: {
                                    padding: 0,
                                    margin: 0,
                                    textAlign: "center",
                                    backgroundColor: "#F0F0F0",
                                    zIndex : 20,
                                },
                                maxBodyHeight: "60vh",
                            }}
                            
                            isLoading = {this.state.loading_checkpoints}
                            components = {{
                                Toolbar: (props) => (
                                    <Fragment>
                                        <Divider />
                                        <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row-reverse",
                                            // height: "5vh",
                                            alignContent: "flex-end",
                                        }}
                                        >
                                            <Tooltip title="Refresh" onClick={this.getCheckpoints}>
                                                <IconButton color="primary">
                                                    <Refresh />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Add" onClick={() => this.setState({...this.state, adding_checkpoint: true})}>
                                                <IconButton color="primary">
                                                    <Add />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </Fragment>
                                )
                            }}
                        />
                    </div>
                </Dialog>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Checkpoints);